import placeholder from "../../assets/images/product-placeholder.png";

export const getFileUrl = ( imageId, api )=> {
  const fileId = imageId;
  return fileId
    ? api.appFiles.getUrl(
      {id: fileId}
    )
    : placeholder;
};